<template>
<div class="chapter">
<div class="inner_page">
<p class="title">DIED IN<br/>
  THE WOOL</p>
<p class="author">Ngaio Marsh</p>
<p class="publisher"><span class="calibre3">F<span class="small">ELONY</span> &amp; M<span class="small">AYHEM</span> P<span class="small">RESS</span> • N<span class="small">EW</span> Y<span class="small">ORK</span></span></p>
<p class="img1"><img alt="" src="Images/frn_fig_002.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?585ecf5c